export const FAQS = [
  {
    q: "Come funziona la spedizione dei vini in Italia?",
    a: "Spediamo in tutta Italia a €7, con spedizione gratuita per ordini superiori a €80. La consegna avviene in 2-4 giorni lavorativi. Ogni bottiglia è protetta con imballaggi dedicati al trasporto di vino per arrivare integra.",
  },
  {
    q: "Posso ritirare il mio ordine direttamente in negozio?",
    a: "Sì, il ritiro in negozio presso l'Enoteca Uvaspina (Via Sacro Cuore 2, Rovigo) è sempre gratuito. Puoi scegliere il giorno e l'orario al checkout, anche in giornata a partire da un'ora dopo l'ordine ed entro gli orari di apertura. Ti avvisiamo quando l'ordine è pronto.",
  },
  {
    q: "Effettuate consegne a domicilio a Rovigo?",
    a: "Sì. La consegna a domicilio locale costa €2,90 entro un raggio di circa 5 km dall'enoteca e viene effettuata entro la giornata lavorativa successiva. È disponibile anche una consegna in giornata: dopo l'acquisto ti contattiamo su WhatsApp per concordare l'orario.",
  },
  {
    q: "Posso ricevere o ritirare la bottiglia già fredda?",
    a: "Sì. Per vini bianchi fermi e bollicine puoi richiedere l'opzione 'fresca': al ritiro in negozio è gratuita (secondo disponibilità), mentre per la consegna a domicilio locale ha un piccolo supplemento di €1.",
  },
  {
    q: "Quali metodi di pagamento accettate?",
    a: "Accettiamo carte di credito e debito (Visa, Mastercard, Maestro, American Express) e PayPal per gli ordini online, oltre al pagamento in contanti o carta direttamente in negozio per gli ordini con ritiro.",
  },
  {
    q: "Il negozio è chiuso in alcuni giorni?",
    a: "L'enoteca è aperta dal martedì al sabato (9:00-12:30 e 16:00-20:00), il lunedì solo il pomeriggio (16:00-20:00) ed è chiusa la domenica. In caso di festività o ferie le date di chiusura non sono selezionabili per ritiro e consegna.",
  },
];
